import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { useState, type ReactNode } from "react";

import { useSelector } from "react-redux";
import {
  CheckIcon,
  CopyIcon,
  SearchIcon,
  ViewIcon,
} from "../../../../../assets/icons";
import {
  copyToClipboard,
  getLoggedUser,
  openLinkInNewTab,
} from "../../../../utils";
import { ActionButton, DetailsActions } from "../../../components/global";

type Props = {
  title: ReactNode;
  isScrolled: boolean;
  isSavingDocument: boolean;
  onOpenFindBar: () => void;
  onSaveDocument: () => void;
  onPrint: () => void;
  docLink?: string | undefined;
  text: string;
};

const JurisprudenceDetailsHeaderActions = ({
  title,
  isScrolled,
  isSavingDocument,
  onOpenFindBar,
  onSaveDocument,
  onPrint,
  docLink,
  text,
}: Props) => {
  const [copied, setCopied] = useState(false);

  const loggedUser = useSelector(getLoggedUser);

  const isIpAccount = loggedUser.origem === "ip_auth";

  const renderActions = ({ hideLabelOnMobile = false } = {}) => (
    <>
      <ActionButton
        icon={<SearchIcon />}
        label="Buscar"
        hideLabelOnMobile={hideLabelOnMobile}
        onClick={onOpenFindBar}
        title="Abrir busca customizada (Ctrl+F)"
      />
      {docLink && (
        <ActionButton
          hideLabelOnMobile={hideLabelOnMobile}
          icon={<ViewIcon />}
          title="Ver acórdão na íntegra"
          label="Ver acórdão"
          onClick={() => openLinkInNewTab(docLink)}
        />
      )}

      <ActionButton
        icon={copied ? <CheckIcon /> : <CopyIcon />}
        hideLabelOnMobile={hideLabelOnMobile}
        label={copied ? "Copiado" : "Copiar"}
        title="Copiar sem formatação"
        onClick={() => {
          if (copied) return;
          setCopied(true);
          copyToClipboard(text);
          setTimeout(() => setCopied(false), 2000);
        }}
      />

      {!isIpAccount && (
        <ActionButton
          icon={<BookmarkBorderOutlinedIcon fontSize="small" />}
          onClick={onSaveDocument}
          disabled={isSavingDocument}
          label={isSavingDocument ? "Salvando..." : "Salvar"}
          hideLabelOnMobile={hideLabelOnMobile}
        />
      )}

      <ActionButton
        icon={<PrintOutlinedIcon fontSize="small" />}
        label="Imprimir"
        hideLabelOnMobile={hideLabelOnMobile}
        onClick={onPrint}
      />
    </>
  );

  return (
    <DetailsActions
      title={title}
      renderActions={renderActions}
      wrapStickyWithContainer={false}
    />
  );
};

export default JurisprudenceDetailsHeaderActions;
